export const TEST_ID = 'rateColumnPicker';

export const COLUMN_OPTION_TEST_ID = 'rateColumnPickerOption';

export const CONFIRM_BUTTON_TEST_ID = 'rateColumnPickerConfirmButton';
